import getWeekDay from '~/utilities/date/getWeekDay';

const DELIVERY_DAYS_TO_SKIP = 4;
const dateOfDelivery = new Date();
dateOfDelivery.setDate(dateOfDelivery.getDate() + DELIVERY_DAYS_TO_SKIP);

const affordableCars = [
  {
    id: 'Cars under',
    copy: 'Cars Under $20,000',
    iconName: 'PriceDrop',
    link: '/cars/filters?cvnaid=eyJwcmljZSI6eyJtaW4iOjc5OTAsIm1heCI6MjAwMDB9fQ==',
    analyticEventDescription: 'Cars Under 20k'
  },
  {
    id: 'Great deals',
    copy: 'Shop Great Deals',
    iconName: 'GreatDeals',
    link: '/cars?cvnaid=eyJmaWx0ZXJzIjp7InRhZ0lkcyI6WzEwNF19fQ',
    analyticEventDescription: 'Shop Great Deals'
  },
  {
    id: 'Four-day delivery',
    copy: `Delivery by ${getWeekDay(dateOfDelivery)}`,
    iconName: 'Delivery',
    link: 'cars/filters?cvnaid=eyJmaWx0ZXJzIjp7ImVhcmxpZXN0RGF5c1RvRGVsaXZlcnkiOiI0In19',
    analyticEventDescription: 'Delivery by',
    additionalCssClass: 'hauler-icon'
  },
  {
    id: 'Shop fuel efficient',
    copy: 'Shop Fuel Efficient',
    iconName: 'GasSavings',
    link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7Im1wZyI6eyJtaW4iOjMwLCJtYXgiOjE1MH19fQ==',
    analyticEventDescription: 'Shop Fuel Efficient'
  }
];

export default affordableCars;
